module.exports = __webpack_public_path__ + "static/video-95c7c1ecc2470c0888e9516530f1d178.mp4";